import InternalAPI from "../../../../../app/axios.js"
import "../types"

/** @borrows InternalAPI */
export default class BannerRepository extends InternalAPI {
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v1/banner"
    }

    /**
     *
     * @param typeBanner
     * @return {Promise<{data: Banner, err: null}|{data: null, err: ErrorState}>}
     */
    async getOne(typeBanner = "homepage") {
        try {
            /** @type {AxiosResponse<Object>} */
            const res = await this.$axios.get(this.endpoint + "?type=" + typeBanner);
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }

    /**
     *
     * @param formData {FormData}
     * @return {Promise<{err: *}|{err: string}|{err: null}>}
     */
    async saveOne(formData) {
        try {
            /** @type {AxiosResponse<Object>}*/
            const res = await this.$axios.put(this.endpoint+"/admin", formData)
            if (res.status === 201) {
                return {err: null}
            }
            return {err: "something went wrong"}
        } catch (err) {
            return {err: this.setErrorMessage(err.response)}
        }
    }
}
